import { Gift } from "lucide-react";

export const BonusesSection: React.FC<{ data: any; theme: any }> = ({
  data,
  theme,
}) => {
  if (!data?.items || data.items.length === 0) return null;

  return (
    <section id="bonuses" className="py-16 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div
            className="inline-flex items-center justify-center w-16 h-16 rounded-full mb-4"
            style={{ backgroundColor: `${theme?.primaryColor || "#10B981"}20` }}
          >
            <Gift
              size={32}
              style={{ color: theme?.primaryColor || "#10B981" }}
            />
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4 text-gray-900">
            {data.sectionTitle || "Exclusive Bonuses"}
          </h2>
          {data.description && (
            <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              {data.description}
            </p>
          )}
        </div>

        <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto">
          {[...data.items]
            .sort((a: any, b: any) => (a.order ?? 0) - (b.order ?? 0))
            .map((bonus: any, i: number) => (
              <div
                key={i}
                className="bg-gradient-to-br from-yellow-50 to-white rounded-xl shadow-lg p-6 border-2 border-yellow-200 hover:border-yellow-400 hover:shadow-xl transition-all"
              >
                <div className="flex items-start gap-4">
                  {bonus.bonusImage && (
                    <img
                      src={bonus.bonusImage}
                      alt={bonus.bonusTitle}
                      className="w-20 h-20 rounded-lg object-cover flex-shrink-0"
                    />
                  )}
                  <div className="flex-1 min-w-0">
                    <div className="flex items-start justify-between gap-2 mb-2">
                      <h3 className="text-lg sm:text-xl font-bold text-gray-900">
                        {bonus.bonusTitle}
                      </h3>
                      {bonus.bonusValue && (
                        <span className="px-3 py-1 bg-yellow-500 text-white text-xs font-bold rounded-full whitespace-nowrap">
                          {bonus.bonusValue}
                        </span>
                      )}
                    </div>
                    <p className="text-gray-600 leading-relaxed">
                      {bonus.bonusDescription}
                    </p>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};
